import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Button, Card } from '@shared/components';

import styles from './SingleReport.less';

interface SingleReportMobileProps {
  name: string | React.ReactNode;
  description?: string;
  onClick: () => void;
  openLabel?: string | React.ReactNode;
}

const SingleReportMobile: React.FC<SingleReportMobileProps> = ({
  name,
  description,
  openLabel,
  onClick,
}) => (
  <Card className={styles.singleReport}>
    <div className={styles.dataContainer}>
      <div className={styles.name}>{name}</div>
      <div className={styles.description}> {description} </div>
    </div>
    <div className={styles.url}>
      <Button noPadding noBorder color="info" size="large" onClick={onClick}>
        {openLabel ? openLabel : <FormattedMessage id="shared.view" />}
      </Button>
    </div>
  </Card>
);

export default SingleReportMobile;
